module.exports = __webpack_public_path__ + "img/未标题-3-08.9af55abb.png";